module.exports = __webpack_public_path__ + "static/our-story-web-view-07d3aeba18ac51b60aa4d369a34e237b.png";